export const FREE_SAMPLE_SLUG = "airtrain-ai";
